<template>
  <div v-if="isMissingRequirements" class="unit-card__alert-bottom prereq">
    <span class="unit-card__alert-bottom-content" :id="`tooltip-prereq-alert-${code}`">
      Pre-requisite not selected <i class="far fa-info-circle"></i>
    </span>
    <button type="button" class="unit-card__alert-bottom-action"
      v-on:click="openSlideOut({component: slideOutComponent, componentProperties: slideOutComponentProperties})">
      See details
    </button>

    <b-tooltip :target="`tooltip-prereq-alert-${code}`" triggers="hover" placement="right" noninteractive>
      You have not selected the pre-requisite for this unit. Please add the pre-requisite unit to your unit selection through the General Electives component
      within Option.
    </b-tooltip>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import inputBuilder from 'common/helpers/input-builder.js'
import preReqValidator from 'common/helpers/pre-req-validator.js'
import SlideOutUnitDetailsView from './slide-out-tree-view/SlideOutUnitDetailsView.vue'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    firstLevelTitle: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView,
      slideOutComponentProperties: {
        relationship: this.item.relationship,
        location: this.item.location,
        firstLevelTitle: this.item.firstLevelTitle
      }
    }
  },
  methods: {
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    })
  },
  computed: {
    ...mapGetters({
      selectedUnitCodes: 'units/getSelectedUnitCodes'
    }),
    convertedPreReqs() {
      return inputBuilder.convertRequisites(this.item.relationship.unit.requisites, 'Prerequisite')
    },
    isMissingRequirements() {
      return !preReqValidator.prerequisitesExistTest(this.item.relationship.code, this.selectedUnitCodes, this.convertedPreReqs)
    }
  }
}
</script>
